export default __webpack_public_path__ + "static/media/DrillPressImg.9c6309c2.jpg";